export default "__VITE_ASSET__D8FoOdPJ__"